import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const TpoStatusDefinitionKind = {
  MILESTONE: 'Milestone',
  TPO_STATUS: 'TpoStatus',
};

export const TpoStatusColor = {
  GRAY: 'Gray',
  BLUE: 'Blue',
  GREEN: 'Green',
  ORANGE: 'Orange',
  RED: 'Red',
  PURPLE: 'Purple',
};

export const TPO_STATUS_LABEL_VARIANT = {
  [TpoStatusColor.GRAY]: LabelVariant.GRAY,
  [TpoStatusColor.BLUE]: LabelVariant.BLUE,
  [TpoStatusColor.GREEN]: LabelVariant.GREEN,
  [TpoStatusColor.ORANGE]: LabelVariant.ORANGE,
  [TpoStatusColor.RED]: LabelVariant.RED,
  [TpoStatusColor.PURPLE]: LabelVariant.PURPLE,
};

// The default fill shade (2) is near-white on the gray ramp, so gray takes a darker fill.
export const TPO_STATUS_GRAY_COLOR_MATCH = {
  backgroundColor: 4,
  color: 8,
  borderColor: 5,
};
